<template>
  <div class="search-container" v-if="authUser">
    <div class="search-icon-container">
      <Sprite class="search-icon" name="search"/>
    </div>
    <input v-model="searchText" @input="onSearchInput" @focus="shouldShowResults = true" ref="search" type="text" class="search-input" placeholder="Search for something">
    <div class="empty-icon-container" v-if="searchText!=''" @click="emptySearchBar">
      <Sprite name="close" class="empty-icon"/>
    </div>
    <div v-if="isSearched && shouldShowResults" class="search-results-container">
      <div v-if="isLoading" class="spinner-container">
        <rp-spinner />
      </div>
      <template v-else>
        <p v-if="!hasSearchResults" class="data-group-empty">No results found for "{{searchText}}"</p>
        <div class="results" v-else>
          <template v-for="(group, index) in searchGroups">
            <div v-if="data[group.arrayName] && data[group.arrayName].length>0" :key="index" class="data-group-container">
              <div class="data-group-label">
                {{group.label}}
              </div>
              <template v-for="(result, index) in data[group.arrayName]">
                <router-link :to="getUrl(result, group.url)" :key="index" v-if="index < 4 || group.show" v-on:click.native="shouldShowResults = false">
                  <div class="result-row">
                    <div v-if="group.icon" class="result-icon-container">
                      <Sprite :name="group.icon" class="result-icon"/>
                    </div>
                    <p class="result-text" v-html="showData(result, group.rules)">
                    </p>
                  </div>
                </router-link>
              </template>
              <div class="show-more-icon-container" v-if="data[group.arrayName].length > 4" @click="openCloseGroup(group)">
                <template v-if="!group.show">
                  SHOW MORE
                </template>
                <template v-else>
                  SHOW LESS
                </template>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Sprite from './Sprite'
import Spinner from './Spinner'

import {mapGetters, mapActions} from 'vuex'

import {adminSearch, distributorSearch, hospitalAdminSearch , search} from '../../api/search'

export default {
  components: {
    'rp-spinner': Spinner,
    Sprite
  },

  data() {
    return {
      isSearched: false,
      isLoading: false,
      shouldShowResults: false,
      searchText: '',
      timer: null,
      searchData: null,
      hasSearchResults: false,
      searchGroups: [
        {
          label: 'SURGEONS',
          arrayName: 'surgeons',
          icon: 'surgeon',
          rules: ['first_name', ' ', 'last_name', ' (', 'email', ')'],
          url: 'surgeons/:id',
          show: false
        }, {
          label: 'NURSES',
          arrayName: 'nurses',
          icon: 'nurse',
          rules: ['first_name', ' ', 'last_name', ' (', 'email', ')'],
          url: 'nurses/:id',
          show: false
        }, {
          label: 'PATIENTS',
          arrayName: 'patients',
          icon: 'patient',
          rules: ['first_name', ' ', 'last_name', ' (', 'email', ') #', 'patient_id'],
          url: 'patients/:id',
          show: false
        }, {
          label: 'SURGERIES',
          arrayName: 'operations',
          rules: ['performed_at|time', ' (', 'first_name', ' ', 'last_name', ')'],
          url: 'operations/:id',
          show: false
        }, {
          label: 'HOSPITALS',
          arrayName: 'hospitals',
          rules: ['name'],
          url: 'hospitals/:id',
          show: false
        }
      ],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },

  mounted() {
    this.$root.$on('logout', () => {
      this.searchText = ''
      this.isSearched = false
    })
  },

  computed: {
    ...mapGetters(['authUser', 'getAuthToken', 'isDistributor', 'isHospitalAdmin']),

    routeByRole() {
      if(this.role === 'Nurse') {
        return '/patients'
      }
      return '/'
    },

    role() {
      return this.authUser ? this.authUser.roles[0].name : null
    }
  },

  methods: {
    openCloseGroup(group) {
      this.$refs.search.focus()
      group.show = group.show ? false : true
    },
    
    getUrl(data, urlRule) {
      let url = ''
      let urlSegments = urlRule.split("/")
      for(let segment of urlSegments) {
        if(segment[0]===':') {
          url += '/' + data[segment.slice(1)]
        } else {
          url += '/' + segment
        }
      }
      return url
    },

    emptySearchBar() {
      this.searchText = ''
      this.onSearchInput(null)
    },

    onSearchInput(event) {
      if(this.searchText.length>=3) {
        this.isSearched = true
        this.search()
      } else {
        this.isSearched = false
      }
    },

    preformSearch() {
      let searchFunction;
      if(this.role === 'raypro_admin') {
        searchFunction = () => { return adminSearch(this.searchText) }
      } else if(this.role === 'nurse' || this.role === 'surgeon') {
        searchFunction = () => { return search(this.searchText) }
      } else if (this.isDistributor) {
        searchFunction = () => { return distributorSearch(this.searchText) }
      } else if (this.isHospitalAdmin) {
        searchFunction = () => { return hospitalAdminSearch(this.searchText) }
      }
      searchFunction().then((res) => {
        this.data = res.data
        this.checkSearchResults()
      }).finally(() => {
        this.isLoading = false
      })
    },

    search() {
      this.isLoading = true
      if(this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.preformSearch, 500)
    },

    checkSearchResults() {
      if(!this.data) {
        this.hasSearchResults = false
        return;
      }
      for(let group of this.searchGroups) {
        if(this.data[group.arrayName] && this.data[group.arrayName].length>0) {
          this.hasSearchResults = true
          return;
        }
      }
      this.hasSearchResults = false
    },

    time(value) {
      const date = new Date(value)
      return date.getDate()
        + " " 
        + this.months[date.getMonth()].toUpperCase() 
        + " " 
        + date.getFullYear()
    },

    showData(value, rules) {
      let result = ''
      this.searchTermHelper = this.searchText;
      for(let rule of rules) {
        if(rule.includes('|')) {
          let pipes = rule.split("|")
          let data = value[pipes[0]]
          for(let i = 1; i < pipes.length; i++) {
            data = this[pipes[i]](data)
          }
          result += this.boldDataUsingSearch(data)
        } else if(value[rule]) {
          result += this.boldDataUsingSearch(value[rule])
        } else {
          result += rule
        }
      }

      return result
    },

    boldDataUsingSearch(text) {
      let result = '';
      let allSearchWords = this.searchText.split(" ")
      for(let i = 0; i<allSearchWords.length; i++) {
        const searchWord = allSearchWords[i]
        if(!text.toLowerCase().includes(searchWord.toLowerCase())) {
          continue;
        }
        const position = text.toLowerCase().indexOf(searchWord.toLowerCase())
        return text.substring(0, position) + '<b>' + text.substring(position, position + searchWord.length) + '</b>' + text.substring(position + searchWord.length)
      }
      return text
    } 
  }
}
</script>

<style lang="sass">
  @import '../../styles/base/_variables.sass'
  @import '../../styles/helpers/_mixins.sass'

  .search-container
    display: flex
    flex-grow: 1

    @media screen and (max-width: 620px)
      margin-top: 30px
      margin-left: 0px
      width: 100%

    .search-icon
      fill: $color-side-nav
      width: 24px
      height: 24px
      margin-right: 10px
      margin-left: 16px

      @media screen and (max-width: 620px)
        margin-left: 8px

    .search-input
      appearance: none
      max-width: 310px
      flex-grow: 1
      font-size: 16px
      font-weight: 400
      border: none
      outline: none
      font-family: $app-font
      color: $color-text

      @media screen and (max-width: 620px)
        max-width: unset

      &::placeholder
        font-weight: 100
        color: $color-text-light

      &:focus ~ .search-results-container
        display: block

    .empty-icon-container
      align-self: center

      @media screen and (max-width: 620px)
        position: absolute
        right: 35px
      
      .empty-icon
        width: 18px
        height: 18px
        fill: $color-text-light

    .search-results-container
      display: none
      position: absolute
      top: 75px
      background-color: grey
      padding: 20px
      width: 100%
      max-width: 400px
      background-color: $color-body-bg
      box-shadow: 2px 3px 5px 0px $color-shadow
      max-height: 80vh
      overflow: scroll

      @media screen and (max-width: 650px)
        max-width: 370px

      @media screen and (max-width: 620px)
        top: 130px
        left: 0
        right: 0
        max-width: unset

      &:hover
        display: block

      .spinner-container
        width: 100%
        min-height: 100px
        display: flex
        justify-content: center
        align-items: center

      .results
        margin-top: -30px

        .data-group-container
          margin-top: 30px

          .data-group-label
            font-size: 12px

          .result-row
            display: flex
            align-items: center
            margin-top: 16px

            .result-icon
              width: 24px
              height: 24px
              margin-right: 10px

            .result-text
              font-size: 14px
              margin: 0 0 0 0

          .show-more-icon-container
            display: flex
            justify-content: center
            margin-top: 10px
            cursor: pointer
            padding: 10px 0

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Search.vue